import React, { FC, useContext } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import NavWrapper from '../components/wrappers/NavWrapper';
import InfoModul from '../pages/Infomodul';
import { userContext } from '../utils/userContext';

const InfomodulRouter: FC = () => {
    let match = useRouteMatch();
    const { hasModule } = useContext(userContext);

    return (
        <div>
            <NavWrapper pageName="Infomodul">
                {!hasModule(match.url) ?
                    <Route component={() => <div>Du har ikke adgang til infomodulet</div>}/>
                : 
                    <Switch>
                        <Route exact path={match.url} component={InfoModul}/>
                        <Route> <div>Siden bliv ikke fundet</div></Route>
                    </Switch>
                }                
            </NavWrapper>
        </div>
    )
}

export default InfomodulRouter;